<div class="generales">

  <div fxLayout="row" fxLayoutAlign="center stretch" >
  <mat-spinner class="cargando" *ngIf="cargando"></mat-spinner>
  </div>

  <div *ngIf="!cargando">
  <h1 class="titutlo">{{'SECCIONES.GENERALES.TITULO' | translate}}</h1>
  <div fxLayout="row" fxLayoutAlign="start center" >
  <h3 id="subtitutlos">{{'SECCIONES.GENERALES.EMPRESA' | translate}} </h3>&nbsp;<h3>{{nombreEmpresa}}</h3>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" >
  <h3 id="subtitutlos">{{'SECCIONES.GENERALES.CT' | translate}} </h3>&nbsp;<h3>{{ct}}</h3>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" >
  <h3 id="subtitutlos">{{'SECCIONES.GENERALES.DOMICILIO' | translate}} </h3>&nbsp;<h3>{{domicilio}}</h3>
  </div>

  <h3 id="subtitutlos">{{'SECCIONES.GENERALES.ACTIVIDAD_P' | translate}}</h3>
  <mat-card><h3>{{actividadP}}</h3></mat-card>

  <h3 id="subtitutlos">{{'SECCIONES.GENERALES.OBJETIVO' | translate}}</h3>
  <mat-card><h3>{{objetivo}}</h3></mat-card>

  <h3 id="subtitutlos">{{'SECCIONES.GENERALES.P_ACTIVIDADESREALIZADAS' | translate}}</h3>
  <mat-card><h3>{{principalesActividades}}</h3></mat-card>

  <div fxLayout="row" fxLayoutAlign="space-between center" >
  <div fxLayout="row" fxLayoutAlign="start center" >
  <h3 id="subtitutlos">{{'SECCIONES.GENERALES.TOTAL_COLABORADORES' | translate}} </h3>&nbsp;<h3>{{totalColaboradores}}</h3>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" >
  <h3 id="subtitutlos">{{'SECCIONES.GENERALES.FECHA_APLICACION' | translate}} </h3>&nbsp;<h3>{{fechaA}}</h3>
  </div>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center" >
  <h3 id="subtitutlos">{{'SECCIONES.GENERALES.TOTAL_ENCUESTADOS' | translate}} </h3>&nbsp;<h3>{{totalEncuestados}}</h3>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center" >
  <h3 id="subtitutlos">{{'SECCIONES.GENERALES.COLABORADORES_NOACEPTARON' | translate}} </h3>&nbsp;<h3>{{noAceptaronEncuesta}}</h3>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center" >
  <h3 id="subtitutlos">{{'SECCIONES.GENERALES.COLABORADORES_SUJETOS_ATS' | translate}} </h3>&nbsp;<h3>{{colaboradoresSujetosAT}}</h3>
  </div>

  <div fxLayout="row" fxLayoutAlign="center center">
  <div class="porcentajeParticipacion">
    <div>
       <div style="display: block">
         <canvas baseChart
           [data]="doughnutChartData"
           [options]="doughnutChartOptions"
           [labels]="doughnutChartLabels"
           [chartType]="doughnutChartType"
           [plugins]="doughnutChartPlugins"
           [colors]="doughnutChartColors">
         </canvas>
       </div>
     </div>
</div>
</div><br>

<div class="graficaSexosResponsive" fxLayoutAlign="center center">
<div fxLayout="row" fxLayoutAlign="center center" id="graficaSexo">
<img src="assets/images/norm35/resuTest/Mujer.png" alt="" id="sexo">
<div style="width:100%;">
  <div>
     <div style="display: block">
       <canvas baseChart
         [data]="mujeresChartData"
         [options]="mujeresChartOptions"
         [labels]="mujeresChartLabels"
         [chartType]="mujeresChartType"
         [plugins]="mujeresChartPlugins"
         [colors]="mujeresChartColors">
       </canvas>
     </div>
   </div>
</div>
</div>

<div fxLayout="row" fxLayoutAlign="center center" id="graficaSexo">
<img src="assets/images/norm35/resuTest/Hombre.png" alt="" id="sexo">
<div style="width:100%;">
  <div>
     <div style="display: block">
       <canvas baseChart
         [data]="hombresChartData"
         [options]="hombresChartOptions"
         [labels]="hombresChartLabels"
         [chartType]="hombresChartType"
         [plugins]="hombresChartPlugins"
         [colors]="hombresChartColors">
       </canvas>
     </div>
   </div>
</div>
</div>
</div> <br>

  <!-- <div fxLayout="row" fxLayoutAlign="center center">
  <button mat-raised-button color="warn">Descargar base de datos</button>
  </div> -->

</div>
  </div>
